import { getUserId } from "../../helpers/storage/user";

export const getChatroomMember = (chatroom) => {
  const { user_id, user, member } = chatroom;
  return user_id === getUserId() ? member : user;
};

const setChatroomOnlineStatus = (chatroom, payload) => {
  if (chatroom?.id.toString() === payload.chatroom_id.toString()) {
    if (chatroom?.member_id?.toString() === payload.user_id.toString())
      return {
        ...chatroom,
        member: { ...chatroom?.member, online_status: payload.status, last_seen: payload.last_seen },
      };
    else
      return {
        ...chatroom,
        user: { ...chatroom?.user, online_status: payload.status, last_seen: payload.last_seen },
      };
  } else return chatroom;
};

const setMultipleChatroomsOnlineStatus = (chatrooms, payload) => {
  return chatrooms.map((chatroom) => {
    if (chatroom?.id.toString() === payload.chatroom_id.toString()) {
      if (chatroom?.member_id?.toString() === payload.user_id.toString())
        return {
          ...chatroom,
          member: { ...chatroom?.member, online_status: payload.status, last_seen: payload.last_seen },
        };
      else
        return {
          ...chatroom,
          user: { ...chatroom?.user, online_status: payload.status, last_seen: payload.last_seen },
        };
    } else return chatroom;
  })
};

export default {
  setChatroomOnlineStatus,
  setMultipleChatroomsOnlineStatus
}
